import { categories } from "@/mocks/categories";

interface AnalysisToolbarProps {
  query: string;
  onQueryChange: (value: string) => void;
  activeCategory: string;
  onCategoryChange: (value: string) => void;
  sort: "latest" | "hot";
  onSortChange: (value: "latest" | "hot") => void;
  resultCount: number;
}

export default function AnalysisToolbar({
  query,
  onQueryChange,
  activeCategory,
  onCategoryChange,
  sort,
  onSortChange,
  resultCount,
}: AnalysisToolbarProps) {
  const tabs = [{ slug: "all", name: "全部" }, ...categories.map((c) => ({ slug: c.slug, name: c.name }))];

  return (
    <div className="sticky top-16 z-30 border-b border-background-200 bg-background-50/95 backdrop-blur">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-4 md:px-8">
        <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
          <div className="flex flex-wrap items-center gap-2">
            {tabs.map((tab) => (
              <button
                key={tab.slug}
                type="button"
                onClick={() => onCategoryChange(tab.slug)}
                className={`whitespace-nowrap rounded-full px-3.5 py-1.5 text-sm transition-colors cursor-pointer ${
                  activeCategory === tab.slug
                    ? "bg-primary-500 text-background-50"
                    : "border border-background-300 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-700"
                }`}
              >
                {tab.name}
              </button>
            ))}
          </div>

          <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
            <div className="relative">
              <span className="pointer-events-none absolute left-3 top-1/2 flex h-4 w-4 -translate-y-1/2 items-center justify-center text-foreground-400">
                <i className="ri-search-line text-sm" aria-hidden="true" />
              </span>
              <input
                type="search"
                value={query}
                onChange={(event) => onQueryChange(event.target.value)}
                placeholder="搜索事件关键词…"
                aria-label="搜索事件关键词"
                className="w-full rounded-md border border-background-300 bg-background-50 py-2.5 pl-9 pr-3 text-sm text-foreground-900 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400 focus:ring-2 focus:ring-primary-100 sm:w-56"
              />
            </div>

            <div className="flex items-center gap-1 rounded-full border border-background-300 bg-background-50 p-1">
              {(
                [
                  { key: "latest", label: "最新" },
                  { key: "hot", label: "最热" },
                ] as const
              ).map((item) => (
                <button
                  key={item.key}
                  type="button"
                  onClick={() => onSortChange(item.key)}
                  className={`whitespace-nowrap rounded-full px-3 py-1.5 text-xs transition-colors cursor-pointer ${
                    sort === item.key
                      ? "bg-secondary-500 text-background-50"
                      : "text-foreground-600 hover:text-foreground-950"
                  }`}
                >
                  {item.label}
                </button>
              ))}
            </div>
          </div>
        </div>

        <p className="mt-3 text-xs text-foreground-500">
          共找到 <span className="font-medium text-foreground-800">{resultCount}</span> 篇解读
        </p>
      </div>
    </div>
  );
}